'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTagUrl = buildTagUrl;
exports.buildTagQBUrl = buildTagQBUrl;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 生成 tag 地址
 * @param {String}  options.id      tagId
 * @param {String}  options.name
 * @param {String}  options.ch      渠道号
 * @param {String}  options.innerCh 内部渠道号
 * @param {Boolean} options.inCh    是否在专区portal内
 * @param {String}  options.env     服务环境，TEST/GRAY
 * @return {String}
 */
function buildTagUrl(_ref) {
  var id = _ref.id,
      name = _ref.name,
      ch = _ref.ch,
      innerCh = _ref.innerCh,
      inCh = _ref.inCh,
      env = _ref.env;

  var TEST = env === 'TEST';
  var baseUrl = TEST ? 'http://tagList.cs0309.html5.qq.com/tagList' : 'https://zixun.html5.qq.com/taglist/tagList';

  var params = _queryString2.default.stringify({
    innerCh: innerCh,
    ch: ch,
    inCh: inCh && 1,
    tagId: id,
    tagName: name
  });

  return baseUrl + '?' + params;
}

/**
 * 生成 tag 的 QB地址
 * @param  {String} options.id
 * @param  {String} options.name
 * @param  {String} options.ch
 * @param  {String} options.listurl tag页面web地址
 * @return {String}
 */
/*
 * @Author: edvardchen
 * @Date:   2016-11-23 14:43:34
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-11-24 20:15:37
 */

function buildTagQBUrl(_ref2) {
  var id = _ref2.id,
      name = _ref2.name,
      ch = _ref2.ch,
      listurl = _ref2.listurl;

  var params = _queryString2.default.stringify({
    mtttitle: name,
    listurl: listurl,
    type: 0,
    ctype: 2,
    b_f: ch
  });
  return 'qb://ext/read?cid=' + id + '&' + params;
}